"use strict";

var _classCallCheck = require("D:\\RAPTIVITY_2020\\raptivity2020\\client\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var user_agent_1 = require("../../utils/user-agent");

var bots = require("../../../fixtures/regexes/bots.json");

var BotParser = function BotParser() {
  _classCallCheck(this, BotParser);

  this.parse = function (userAgent) {
    var _a, _b, _c, _d;

    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      for (var _iterator = bots[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var bot = _step.value;
        var match = user_agent_1.userAgentParser(bot.regex, userAgent);
        if (!match) continue;
        return {
          name: bot.name,
          category: bot.category || "",
          url: bot.url || "",
          producer: {
            name: ((_b = (_a = bot) === null || _a === void 0 ? void 0 : _a.producer) === null || _b === void 0 ? void 0 : _b.name) || "",
            url: ((_d = (_c = bot) === null || _c === void 0 ? void 0 : _c.producer) === null || _d === void 0 ? void 0 : _d.url) || ""
          }
        };
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return != null) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return null;
  };
};

module.exports = BotParser;